export default __webpack_public_path__ + "static/media/uniswap.394b7ed6.png";